import {
  CreatePostRequest,
  DeletePostRequest,
  SearchPostsRequest,
  UpdatePostRequest,
  ViewPostHierarchyRequest,
  ViewPostsRequest
} from './post.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/post`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreatePostRequest = (data: CreatePostRequest): [string, HttpPostOptions<CreatePostRequest>] => [
  getEndpoint(),
  getHttpPostOptions(data)
];

export const getViewPostsRequest = (data: ViewPostsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.programmeExternalReference}`,
  getHttpGetOptions(undefined, {
    searchType: data.searchType!,
    page: String(data.page),
    size: String(data.size),
    memberExternalReference: data.memberExternalReference!
  })
];

export const getUpdatePostRequest = (data: UpdatePostRequest): [string, HttpPutOptions<UpdatePostRequest>] => [
  getEndpoint(),
  getHttpPutOptions(data)
];

export const getDeletePostRequest = (data: DeletePostRequest): [string, HttpDeleteOptions] => [
  `${getSpecificEndpoint(data.postExternalReference)}`,
  getHttpDeleteOptions()
];

export const getSearchPostsRequest = (data: SearchPostsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.programmeExternalReference}/${data.searchText}`,
  getHttpGetOptions(undefined, { memberExternalReference: data.memberExternalReference! })
];

export const getViewPostHierarchyRequest = (data: ViewPostHierarchyRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/view/post-hierarchy/${data.postExternalReference}`,
  getHttpGetOptions()
];
